// eslint-disable-next-line import/prefer-default-export
export function getCountriesList() {
  return window.axios.get('/api/countries?unsanctioned=1');
}
